import { NgModule } from "@angular/core";
import { BarcodeScannerNative } from "./barcode-scanner.native";
import { FcmNative } from "./fcm.native";
import { GeolocationNative } from "./geolocation.native";
import { BackgroundGeolocationNative } from "./background-geolocation.native";
import { FileTransferNative } from "./file-transfer.native";
import { NetworkTracerNative } from "./network-tracer.native";
import { GreatdayPluginNative } from "./greatday-plugin.native";
import { CameraNative } from "./camera.native";
import { ImagePickerNative } from "./image-picker.native";
import {ScreenshotNative} from './screenshot.native';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    BarcodeScannerNative,
    GeolocationNative,
    FcmNative,
    BackgroundGeolocationNative,
    FileTransferNative,
    NetworkTracerNative,
    GreatdayPluginNative,
    CameraNative,
    ImagePickerNative,
    ScreenshotNative,
  ]
})
export class NativeModule {
}



// WEBPACK FOOTER //
// ./src/native/native.module.ts